///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.bid_review = abcsetup.consumer_rfp.bid_review || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.bid_review.edit = {
    supplierContractEditor: null,

    init() {
        abcsetup.setTitle('Consumer RFP - Bid Review');

        this._setupBindings();
        this._setupTableCounts();
        this._setupAwardRejectButtons();
        this._setupAwardSendQuote()
        this._setupChallengerBidsToggle();
        this._syncSupplierContracts();
        this._setupRejectButton();
    },

    _setupBindings() {
        // Toggle whether samples were received.
        $(document).on('click', '.btn_samples_received', event => {
            const button = $(event.target).closest('.btn_samples_received');
            const bidId = button.data('bidId');
            if (!bidId) {
                console.error('No bid ID given on element: ', event.target);
            }

            abcsetup.blockUI(true);

            axios.put(`/api/consumer_rfp/bids/${bidId}/samples_received`, {
                were_received: button.data('wereReceived') ? 0 : 1, // toggling whether they were received.
            }).then(({data}) => {
                button.data('wereReceived', button.data('wereReceived') ? 0 : 1); // update what the button is reporting as the received state internally.
                button.html(button.data('wereReceived') ? '<i class="fas fa-toggle-on"></i>' : '<i class="fas fa-toggle-off"></i>'); // set button content based on current received state.
                button.toggleClass('text-success', button.data('wereReceived')); // Set button text based on received state.
                const newButtonTitle = button.data('wereReceived') ? 'Samples received: ' + moment(data.samples_received_at).format('MMMM Do YYYY h:mm a') : '';
                button.attr('title', newButtonTitle); // Add received date to button, if we have one.
                button.attr('data-original-title', newButtonTitle); // Add received date to button, if we have one.
                var awardButton = $("input[name='bids[" + data.bidId + "][consumer_rfp_bid_status_id]'].award");
                console.log('bidId = '+data.bidId)
                if ( button.data('wereReceived') ) {
                    awardButton.attr('disabled',false);
                    awardButton.closest('label').attr('title','Award');
                    awardButton.closest('label').attr('data-original-title','Award');
                    awardButton.closest('label').removeClass('disabled');
                    awardButton.closest('label').attr('disabled',false);
                } else {
                    this._resetBidStatus(awardButton.closest('tr'));
                    awardButton.attr('disabled',true);
                    awardButton.closest('label').attr('title','Can not award unless all samples are received');
                    awardButton.closest('label').attr('data-original-title','Can not award unless all samples are received');
                    awardButton.closest('label').removeClass('active');
                    awardButton.closest('label').addClass('disabled');
                    awardButton.closest('label').attr('disabled',true);
                }
                abcsetup.unblockUI();
            });
        });

        // Not participating toggle.
        $('#no_response_table_container').hide();
        $(document).on('change', '[name=not_participating_toggle]', function () {
            if ($(this).val() === 'bid_refused') {
                $('#bids_refused_table_container').show();
                $('#no_response_table_container').hide();
            } else {
                $('#bids_refused_table_container').hide();
                $('#no_response_table_container').show().find('.datatable').css('width', '100%');
            }
        });
    },

    /**
     * Get the numbers to show on the badges for the toggle, if any.
     *
     * @private
     */
    _setupTableCounts() {
        $('#bids_refused_table_container .datatable').on('xhr.dt', (event, settings, json) => {
            const numberContainer = $('#not-participating-toggle label:has(input[value=bid_refused]) .number_container');

            if (json.recordsTotal > 0) {
                numberContainer.show().text(`(${json.recordsTotal})`);
            } else {
                numberContainer.hide();
            }
        });

        $('#no_response_table_container .datatable').on('xhr.dt', (event, settings, json) => {
            const numberContainer = $('#not-participating-toggle label:has(input[value=no_response]) .number_container');

            if (json.recordsTotal > 0) {
                numberContainer.show().text(`(${json.recordsTotal})`);
            } else {
                numberContainer.hide();
            }
        });

        $('#bid-review-table-container .datatable').on('xhr.dt', (event, settings, json) => {
            const numberContainer = $('#challenger-bids-toggle label:has(input[value=bids]) .number_container');

            if (json.recordsTotal > 0) {
                numberContainer.show().text(`(${json.recordsTotal})`);
            } else {
                numberContainer.hide();
            }
        });
    },

    /**
     * Setup the bindings for approving and rejecting individual bids.
     *
     * @private
     */
    _setupAwardRejectButtons() {
        $(document).on('click', 'label.award_btn,label.reject_btn', event => {
            event.preventDefault();
            const awardRejectButton = $(event.target).closest('label');
            const wasAlreadyChecked = awardRejectButton.find('input').prop('checked');

            if (awardRejectButton.find('input').is(':disabled')){
                // if the option is disabled return
                return;
            }

            if (wasAlreadyChecked) { // Unchecking a checked checkbox. Work is already done for this action.
                this._resetBidStatus(awardRejectButton.closest('tr'));
                return;
            }

            if (awardRejectButton.hasClass('btn-outline-success')) {
                this._awardBid(awardRejectButton.closest('tr'));
            } else {
                this._rejectBid(awardRejectButton.closest('tr'));
            }
        });

        // Initialize rows.
        $('#bid-review-table-container .datatable').on('draw.dt', (event, settings, json) => {
            $('.bid-status-toggle').each(event => {
                const activeButton = $(event.target).find('.active');
                const row = $(event.target).closest('tr');
                const rejectComment = row.find('.reject_comment');

                if (activeButton.hasClass('btn-outline-success')) {
                    rejectComment.show();
                    return this._awardBid(row, true);
                } else if (activeButton.hasClass('btn-outline-danger')) {
                    rejectComment.hide();
                    return this._rejectBid(row, true);
                }

                this._resetBidStatus(row, true);
            });
        });
    },

    _setupAwardSendQuote() {
        $(document).on('click', 'label.quote_btn', event => {
            event.preventDefault();
            const quoteButton = $(event.target).closest('label');
            const wasAlreadyChecked = quoteButton.find('input').prop('checked');

            if (wasAlreadyChecked) { // Unchecking a checked checkbox. Work is already done for this action.
                this._resetBidStatus(quoteButton.closest('tr'));
                return;
            }

            if (quoteButton.hasClass('quote_btn')) {
                this._quoteBid(quoteButton.closest('tr'));
            }

        });
    },
    /**
     * Reset the given row's approval status.
     *
     * @param row
     * @param initialRun
     * @private
     */
    _resetBidStatus(row, initialRun = false) {
        const bidStatusToggle = $(row).find('.bid-status-toggle');

        bidStatusToggle.find('label').removeClass('active');
        bidStatusToggle.find('input')
            .prop('checked', false)
            .trigger('change', {revalidate: !initialRun});

        $(row).removeClass('award done reject')
            .find('.hidden-for-reject')
            .removeClass('hidden-for-reject')
            .parents('.cell-container')
            .children()
            .show();
        $(row).find('[name*=rejection_comments]')
            .parents('.cell-container')
            .children()
            .hide();
        $(row).find('[name*=comments]')
            .removeClass('invalid')
            .attr('required',false)
            .parents('.cell-container')
            .children()
            .hide();

        this._syncSupplierContracts();
    },

    /**
     * Award the bid in the given row.
     *
     * @param row
     * @param initialRun
     * @private
     */
    _awardBid(row, initialRun = false) {
        const awardButton = $(row).find('.bid-status-toggle .btn-outline-success');

        this._resetBidStatus(row);

        awardButton.addClass('active');
        awardButton.find('input')
            .prop('checked', true)
            .trigger('change', {revalidate: true});

        row.find('[name*=humana_requested_supplier_quote]')
            .val('')
            .hide();

        $(row).removeClass('reject').addClass('done award');

        if (!initialRun) {
            const bidStatusToggle = awardButton.closest('.bid-status-toggle');
            // Mark the same item for other suppliers as rejected.
            $(`.bid-status-toggle.item_${bidStatusToggle.data('consumer_rfp_item_id')} .award_btn:has(input[type=radio]:checked)`)
                .not(awardButton)
                .toArray()
                .map(awardButton => $(awardButton).closest('.bid-status-toggle').find('.reject_btn'))
                .forEach(rejectButton => rejectButton.trigger('click'));
        }

        this._syncSupplierContracts();
    },

    /**
     * Reject the bid in the given row.
     *
     * @param row
     * @param {boolean} initialRun
     * @private
     */
    _rejectBid(row, initialRun = false) {
        const $row = $(row);
        const rejectButton = $row.find('.bid-status-toggle .btn-outline-danger');

        this._resetBidStatus(row);

        rejectButton.addClass('active');
        rejectButton.find('input')
            .prop('checked', true)
            .trigger('change', {revalidate: true});

        $row.removeClass('award').addClass('done reject')
            .find(':input:visible:not([name*=consumer_rfp_bid_status_id],[name*=rejection_comments],[name*=comments]),.select2-hidden-accessible')
            .parents('.cell-container')
            .children()
            .addClass('hidden-for-reject')
            .hide()
        $row.find('[name*=rejection_comments]')
            .parents('.cell-container')
            .children()
            .show();
        $row.find('[name*=comments]')
            .parents('.cell-container')
            .children()
            .show();
        $row.find('[name*=humana_requested_supplier_quote]')
            .val('')
            .hide();

        this._syncSupplierContracts();
    },

    /**
     * Quote the bid in the given row.
     *
     * @param row
     * @param {boolean} initialRun
     * @private
     */
    _quoteBid(row, initialRun = false) {
        const $row = $(row);
        const quoteButton = $row.find('.bid-status-toggle .btn-outline-dark');

        this._resetBidStatus(row);

        quoteButton.addClass('active');
        quoteButton.find('input')
            .prop('checked', true)
            .trigger('change', {revalidate: true});

        $row.removeClass('award').addClass('done reject')
            .find(':input:visible:not([name*=consumer_rfp_bid_status_id],[name*=rejection_comments]),[name*=comments]),.select2-hidden-accessible')
            .parents('.cell-container')
            .children()
            .addClass('hidden-for-reject')
            .hide()
        $row.find('[name*=humana_requested_supplier_quote]')
            .show();

        this._syncSupplierContracts();
    },

    /**
     * Toggling between "Bids" and "Contracts".
     * @private
     */
    _setupChallengerBidsToggle() {
        const contractsContainer = $('#supplier-contracts-container');
        contractsContainer.hide();
        $(document).on('change', '[name=challenger_bids_toggle]', function () {
            $('#challenger_bids_toggle-toggle .btn').removeClass('active');
            $('#bid-review-table-container').toggle($(this).val() !== 'supplier_contracts');
            contractsContainer.toggle($(this).val() === 'supplier_contracts');
        });
    },

    /**
     * For each supplier that has an awarded bid, we provide a way to manage the contract for that supplier for this CRFP.
     * @private
     */
    _syncSupplierContracts() {
        if ($('#supplier-contracts-container').data('readonly')) {
            return;
        }

        const supplierContractsTableBody = $('#supplier-contracts-container .table tbody')
        const rowTemplate = supplierContractsTableBody.find('.row-template');

        const activeAwardButtons = $('label.award_btn.active');
        if (activeAwardButtons.length === 0) {
            supplierContractsTableBody.find('tr:not(.row-template,.no-awarded-suppliers-message)').remove();
            supplierContractsTableBody.find('.no-awarded-suppliers-message').show();
            return;
        }

        supplierContractsTableBody.find('.no-awarded-suppliers-message').hide();

        // Add missing.
        const awardedOrgIds = activeAwardButtons.toArray().map(awardButton => { // a bit of a side-effect map :)
            const supplierRow = rowTemplate.clone();
            const buttonGroup = $(awardButton).closest('.btn-group');
            const alreadyHaveSupplier = supplierContractsTableBody.find('.contract-btn').toArray().some(contractButton => $(contractButton).data('orgId') == buttonGroup.data('orgId'));

            if (!alreadyHaveSupplier) {
                supplierRow.find('.supplier-name').text(buttonGroup.data('orgName'));
                supplierRow.find('.contract-btn')
                    .data('orgId', buttonGroup.data('orgId'))
                    .data('orgName', buttonGroup.data('orgName'))
                    .on('click', event => this._openContractModal($(event.target).closest('.btn')))
                supplierRow.removeClass('row-template').removeClass('hide');
                supplierContractsTableBody.append(supplierRow);
            }

            return buttonGroup.data('orgId');
        });

        // Remove those without any awards.
        supplierContractsTableBody.find('tr:not(.row-template) .contract-btn').toArray().forEach(contractButton => {
            if (awardedOrgIds.includes($(contractButton).data('orgId'))) {
                return;
            }

            $(contractButton).closest('tr').remove();
        });

        // Show the, "we don't have any awarded suppliers" message if we don't have any yet.
        if (supplierContractsTableBody.find('tr:not(.row-template,.no-awarded-suppliers-message)').length === 0) {
            supplierContractsTableBody.find('.no-awarded-suppliers-message').show();
        }
    },

    async _openContractModal(contractButton) {
        const orgName = $(contractButton).data('orgName');
        const contractModal = $('#supplier-contract-modal');
        const contractInput = $(`#supplier-contracts-container input.supplier-contracts-${$(contractButton).data('orgId')}`);

        if (!this.supplierContractEditor) {
            await CKEDITOR.create(contractModal.find('textarea.editor').get(0), CKEDITOR.config)
                .then(editor => {
                    this.supplierContractEditor = editor;
                });
        }

        contractModal
            .find('.modal-title')
            .text(`Edit Contract: ${orgName}`);

        contractModal.find('.reset-to-default-btn')
            .off('click')
            .on('click', event =>
                this.supplierContractEditor.setData($(event.target).data('defaultContract') || '')
            );

        this.supplierContractEditor.setData(contractInput.val() || '');

        contractModal.find('.save-contract-btn').off('click').on('click', () => {
            contractModal.modal('hide');
            contractInput.val(this.supplierContractEditor.getData());
        });

        contractModal.modal('show');
    },

    uploadDone() {
        if (abcsetup.uploader.uploadResult.consumer_rfp_id) {
            let msg = '';

            if (abcsetup.uploader.uploadResult.success) {
                msg += 'Successfully imported'; // success is always returned. We'll get a validation exception when something goes wrong.
            }

            $('#bid-review-table-container .datatable').DataTable().ajax.reload();
            abcsetup.alerts.show('Import Bid Review', msg);
        }
    },

    /**
     * When reject button is clicked, ask for some info.
     */
    _setupRejectButton() {
        $('#btn-reject').on('click', event => {
            event.preventDefault();
            const form = event.target.form;

            const handleClose = ([clickedOk, inputText]) =>
                clickedOk && $(form.reject_reason).val(inputText).get(0).form.submit();

            $(form.form_action).val('reject');
            $(form.save_type).val('reject');
            abcsetup.alerts.prompt('Reject Consumer RFP', 'Reason for rejection:', handleClose, false, false, {textarea: true})
        });
    },
}
